<template>
  <q-form @submit="this.onSubmit" class="ms-form ms-form--narrow reject-form">
    <div class="ms-form-grid ms-form-grid--single">
      <div>
        <CustomInput
          label="Комментарий к отказу"
          type="textarea"
          :required="true"
          :value="this.formData.decision_comment"
          @change_input="this.onCommentChange"
          @clear_input="this.onCommentChange"
        />
        <div v-if="this.validationError" class="reject-form__error">
          {{ this.validationError }}
        </div>
      </div>
    </div>
    <CustomModalFooter
      submitBtnText="Отказать"
      :btnLoading="this.loading"
    />
  </q-form>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "ProviderRequestAdditionReject",
  components: {
    CustomInput,
    CustomModalFooter,
  },
  props: ["data"],
  data() {
    return {
      loading: false,
      validationError: "",
      formData: {
        decision_comment: "",
      },
    };
  },
  methods: {
    onCommentChange(value) {
      this.formData.decision_comment = value;
      if (String(value || "").trim()) {
        this.validationError = "";
      }
    },
    async onSubmit() {
      const decisionComment = String(
        this.formData.decision_comment || ""
      ).trim();

      if (!decisionComment) {
        this.validationError = "Комментарий обязателен";
        return;
      }

      this.loading = true;
      await this.data?.onSubmit({
        decision_comment: decisionComment,
      });
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
// Сетка — общая (ms-form-* в theme.scss)
.reject-form {
  &__error {
    margin-top: 6px;
    color: var(--ms-danger);
    font-size: 12px;
  }
}
</style>
